import { ref } from 'vue';

const getDivisions = () => {
    const divisions_error = ref(null);
    const divisions = ref(null);

    const loadDivisions = async () => {
      try {
        let data = await fetch("/api/divisions");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        divisions.value = await data.json();

        // console.log('clients', clients.value);
      } catch (err) {
        divisions_error.value = err.message;
      }
    };

    return { divisions, divisions_error, loadDivisions};
}

export default getDivisions;